import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SideNav from "./SideNav";
import { fetchProfile } from "../../services/api";

/**
 * ProjectsPortfolio – 3‑column grid showcasing Digis projects.
 * Fetches the logged‑in user's profile so the sidebar greets them.
 */
const ProjectsPortfolio = () => {
  const [profile, setProfile] = useState(null);
  const token = localStorage.getItem("authToken");
  const navigate = useNavigate();

  useEffect(() => {
    const loadProfile = async () => {
      try {
        const data = await fetchProfile(token);
        setProfile(data);
      } catch (err) {
        console.error("Error fetching profile in ProjectsPortfolio:", err);
      }
    };
    loadProfile();
  }, [token]);

  const handleLogout = () => navigate("/logout");

  const projects = [
    {
      id: 1,
      title: "Noty.ai",
      image: "https://res.cloudinary.com/dnbbm9vzi/image/upload/v1751801788/Screenshot_2025-07-06_at_12.36.09_PM_wzzjua.png",
      url: "https://app.noty.ai/sign-in",
    },
    {
      id: 2,
      title: "Gem Hub",
      image: "https://res.cloudinary.com/dnbbm9vzi/image/upload/v1751801904/Screenshot_2025-07-06_at_12.37.58_PM_pfm55o.png",
      url: "https://hub.gemlightbox.com/auth/signup",
    },
    {
      id: 3,
      title: "SENDY",
      image: "https://res.cloudinary.com/dnbbm9vzi/image/upload/v1751803851/Screenshot_2025-07-06_at_1.10.21_PM_dfunjz.png",
      url: "https://sendy.io/sign-up",
    },
    {
      id: 4,
      title: "Fiverr",
      image: "https://res.cloudinary.com/dnbbm9vzi/image/upload/v1751804096/Screenshot_2025-07-06_at_1.14.27_PM_c0vue2.png",
      url: "https://www.fiverr.com/",
    },
    {
      id: 5,
      title: "HubSpot",
      image: "https://res.cloudinary.com/dnbbm9vzi/image/upload/v1751804297/Screenshot_2025-07-06_at_1.17.20_PM_lyifkg.png",
      url: "https://app.hubspot.com/signup-hubspot/crm",
    },
    {
      id: 6,
      title: "ongage",
      image: "https://res.cloudinary.com/dnbbm9vzi/image/upload/v1751803991/Screenshot_2025-07-06_at_1.12.15_PM_x0sb5j.png",
      url: "https://www.ongage.com/registration/",
    },
    {
      id: 7,
      title: "GrapeData",
      image: "https://res.cloudinary.com/dnbbm9vzi/image/upload/v1751803739/Screenshot_2025-07-06_at_12.42.43_PM_uxuqke.png",
      url: "https://user-app.grape-data.com/sign-up/enter-email",
    },
    {
      id: 8,
      title: "View More Projects",
      image: "https://res.cloudinary.com/dnbbm9vzi/image/upload/v1751804540/Screenshot_2025-07-06_at_1.22.04_PM_g2sjjp.png",
      url: "https://digiscorp.com/portfolio/",
    },
    {
      id: 9,
      title: "View Client Feedback",
      image: "https://res.cloudinary.com/dnbbm9vzi/image/upload/v1751810690/Screenshot_2025-07-06_at_3.04.34_PM_lbyare.png",
      url: "https://clutch.co/profile/digis#reviews",
    },
    {
      id: 10,
      title: "View Upwork History",
      image: "https://res.cloudinary.com/dnbbm9vzi/image/upload/v1751810690/Screenshot_2025-07-06_at_3.04.17_PM_sy24z3.png",
      url: "https://www.upwork.com/agencies/digis/",
    },
  ];

  return (
    <div className="dashboard-background">
      <div className="container-fluid">
        <div className="row">
          {/* Sidebar */}
          <SideNav userProfile={profile} handleLogout={handleLogout} />

          {/* Main Content */}
          <main
            className="col-md-9 ms-sm-auto col-lg-10 px-4 d-flex flex-column"
            style={{ minHeight: "100vh" }}
          >
            {/* Logo & heading */}
            <div className="text-center mt-3 mb-4 d-flex align-items-center justify-content-center">
              <img
                src="https://res.cloudinary.com/dnbbm9vzi/image/upload/v1747769920/logo_oq3zwy.png"
                alt="Logo"
                style={{ width: 50, height: 50, marginRight: 10 }}
              />
              <h1 className="d-inline mb-0 fw-bold">Digis Customer Portal</h1>
            </div>

            {/* Portfolio Section */}
            <div className="flex-grow-1 d-flex flex-column align-items-center w-100">
              <h2 className="fw-bold text-center mt-3">Our Projects</h2>
              <p className="text-center text-dark fs-5 mb-4">
                Explore a selection of the products, platforms and custom solutions we’ve built for clients around the globe.
              </p>

              {/* 3‑column responsive grid */}
              <div className="row g-4 w-100">
                {projects.map(({ id, title, image, url }) => (
                  <div key={id} className="col-12 col-md-6 col-lg-4">
                    <a
                      href={url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-decoration-none"
                    >
                      <div
                        className="card h-100 shadow-sm border-0"
                        style={{ cursor: "pointer", transition: "transform 0.3s" }}
                        onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.02)")}
                        onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                      >
                        <img
                          src={image}
                          alt={title}
                          className="card-img-top"
                          style={{ height: 200, objectFit: "cover" }}
                        />
                        <div className="card-body text-center">
                          <h5 className="card-title mb-0 fw-semibold text-dark">
                            {title}
                          </h5>
                        </div>
                      </div>
                    </a>
                  </div>
                ))}
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default ProjectsPortfolio;
